<!-- Modals -->
<ui-dialog
    *ngIf="activePaystub && activePaystub.employee"
    [open]="currentlyOpenDialog === 'PAYSTUB_DETAILS'"
    (closing)="closeDialog()"
    header="{{ activePaystub.employee.firstName }} {{ activePaystub.employee.lastName }}"
    [headerBadge]="
        activePaystub.employee.isTerminated
            ? { type: 'danger', translationKey: 'forms.payroll-review.terminated' }
            : undefined
    "
>
    <app-paystub-view-details *ngIf="activePaystub" [paystub]="activePaystub" />
</ui-dialog>

<ui-dialog
    [open]="currentlyOpenDialog === 'OTHER_REMITTANCES'"
    [size]="'small'"
    [isCloseable]="true"
    [header]="'forms.payroll-review.otherRemittances' | translate"
    (closing)="closeDialog()"
>
    <app-other-remittances-details [payroll]="payroll" />
</ui-dialog>

<form #form="ngForm" class="ui form">
    <div class="payroll-summary extra-remittances">
        <div class="payroll-obligation card">
            <app-segment-header [title]="'forms.payroll-review.payrollObligation'"></app-segment-header>
            <form class="ui static form">
                <div class="inline field text-large">
                    <label>{{ 'forms.payroll-review.employeeNetPay' | translate }}</label>
                    {{ payroll.netAmount | i18nNum: '$' }}
                </div>
                <div class="inline field text-large">
                    <label>{{ 'forms.payroll-review.craRemittances' | translate }}</label>
                    {{ payroll.statutoryAmount | i18nNum: '$' }}
                </div>
                <div *ngIf="showQcRemittances" class="inline field text-large">
                    <label>{{ 'forms.payroll-review.revenueQuebecRemittances' | translate }}</label>
                    {{ payroll.totalRqDeductions | i18nNum: '$' }}
                </div>
                <div class="inline field text-large">
                    <label>{{ 'forms.payroll-review.otherDeductions' | translate }}</label>
                    {{ payroll.otherDeductions | i18nNum: '$' }}
                </div>
                <div class="inline field text-large font-bold margin-top-4">
                    <label>{{ 'forms.payroll-review.totalPayrollObligation' | translate }}</label>
                    {{ payroll.liability | i18nNum: '$' }}
                </div>
                <div class="inline field margin-top-4">
                    <label>{{ 'forms.payroll-review.reimbursements' | translate }}</label>
                    {{ payroll.reimbursementAmount | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.accountDebit' | translate }}</label>
                    {{ payroll.debitAmount | i18nNum: '$' }}
                </div>
            </form>
        </div>
        <!-- Net Pay -->
        <div class="net-pay card">
            <h3 class="margin-bottom-4">{{ 'forms.payroll-review.employeeNetPay' | translate }}</h3>
            <form class="ui static form">
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.directDeposit' | translate }}</label>
                    {{ payroll.netAmountDebitable | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.payByCheque' | translate }}</label>
                    {{ payroll.netAmountChequeable | i18nNum: '$' }}
                </div>
                <div class="inline field font-bold margin-top-4">
                    <label>{{ 'forms.payroll-review.employeeNetPayTotal' | translate }}</label>
                    {{ payroll.netAmount | i18nNum: '$' }}
                </div>
            </form>
        </div>
        <!-- Other Remittances -->
        <div class="other-remittances card">
            <div class="flex justify-space-between align-items-center margin-bottom-3">
                <h3>{{ 'forms.payroll-review.otherRemittances' | translate }}</h3>
                <ui-button type="outline" (click)="currentlyOpenDialog = 'OTHER_REMITTANCES'">{{
                    'forms.payroll-review.details' | translate
                }}</ui-button>
            </div>
            <ui-banner variant="warning">
                <p>{{ 'forms.payroll-review.humiDoesNotRemitThesePayments' | translate }}</p>
            </ui-banner>
            <form class="ui static form margin-top-3">
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.workersCompensation' | translate }}</label>
                    {{ payroll.totalWcbPremiums | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.provincialHealthAndEducation' | translate }}</label>
                    {{ payroll.totalEptSummariesNonQc | i18nNum: '$' }}
                </div>
                <div class="inline field font-bold">
                    <label>{{ 'forms.payroll-review.otherRemittancesTotal' | translate }}</label>
                    {{ payroll.totalOtherRemittances | i18nNum: '$' }}
                </div>
            </form>
        </div>
        <div class="cra-remittances card">
            <h3 class="margin-bottom-4">{{ 'forms.payroll-review.craRemittances' | translate }}</h3>

            <form class="ui static form">
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.cpp' | translate }}</label>
                    {{ payroll.cppDeductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.cpp2' | translate }}</label>
                    {{ payroll.cpp2Deductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.ei' | translate }}</label>
                    {{ payroll.eiDeductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.employerCpp' | translate }}</label>
                    {{ payroll.employerCppDeductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.employerCpp2' | translate }}</label>
                    {{ payroll.employerCpp2Deductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.employerEi' | translate }}</label>
                    {{ payroll.employerEiDeductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.incomeTax' | translate }}</label>
                    {{ payroll.incomeTaxDeductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.federalLumpSumDeductions' | translate }}</label>
                    {{ payroll.federalLumpSumDeductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.provincialCraLumpSumDeductions' | translate }}</label>
                    {{ payroll.provincialCraLumpSumDeductions?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field font-bold margin-top-4">
                    <label>{{ 'forms.payroll-review.craRemittancesTotal' | translate }}</label>
                    {{ payroll.totalCraDeductions | i18nNum: '$' }}
                </div>
            </form>
        </div>

        <!-- QC Remittances -->
        <div class="qc-remittances card" *ngIf="showQcRemittances">
            <h3 class="margin-bottom-4">{{ 'forms.payroll-review.revenueQuebecRemittances' | translate }}</h3>

            <form class="ui static form">
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.qpp' | translate }}</label>
                    {{ payroll.qppDeduction?.amount | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.qpp2' | translate }}</label>
                    {{ payroll.qpp2Deduction?.amount | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.qpip' | translate }}</label>
                    {{ payroll.qpipDeduction?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.employerQpp' | translate }}</label>
                    {{ payroll.employerQppDeduction?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.employerQpp2' | translate }}</label>
                    {{ payroll.employerQpp2Deduction?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.employerQpip' | translate }}</label>
                    {{ payroll.employerQpipDeduction?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.incomeTaxQc' | translate }}</label>
                    {{ payroll.incomeTaxRqDeduction?.amount || '0' | i18nNum: '$' }}
                </div>
                <div class="inline field">
                    <label>{{ 'forms.payroll-review.cnesst' | translate }}</label>
                    {{ payroll.cnesstAmount | i18nNum: '$' }}
                </div>

                <!-- QHSF -->
                <div class="inline field" *ngFor="let eptSummary of payroll.eptSummariesQc">
                    <label>{{ eptSummary.details.displayName }}</label>
                    {{ eptSummary.periodBalanceDue | i18nNum: '$' }}
                </div>

                <div class="inline field">
                    <label>{{ 'forms.payroll-review.provincialRqLumpSumDeductions' | translate }}</label>
                    {{ payroll.provincialRqLumpSumDeductions?.amount || '0' | i18nNum: '$' }}
                </div>

                <div class="inline field font-bold margin-top-4">
                    <label>{{ 'forms.payroll-review.revenueQuebecRemittancesTotal' | translate }}</label>
                    {{ payroll.totalRqDeductions | i18nNum: '$' }}
                </div>
            </form>
        </div>
    </div>

    <div class="card margin-top-6">
        <table class="ui selectable table">
            <thead>
                <tr>
                    <th>{{ 'forms.payroll-review.employee' | translate }}</th>
                    <th class="collapsing right aligned">{{ 'forms.payroll-review.grossPay' | translate }}</th>
                    <th class="collapsing right aligned">{{ 'forms.payroll-review.deductions' | translate }}</th>
                    <th class="collapsing right aligned">{{ 'forms.payroll-review.netPay' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let paystub of paystubService.payStubs | async" (click)="showRecord(paystub)">
                    <td>
                        {{ paystub.employee?.firstName }} {{ paystub.employee?.lastName }}
                        <ui-badge *ngIf="paystub.employee?.isTerminated" type="danger">{{
                            'forms.payroll-review.terminated' | translate
                        }}</ui-badge>
                    </td>
                    <td class="right aligned">{{ paystub.grossPay | i18nNum: '$' }}</td>
                    <td class="right aligned">{{ paystub.deductionsAmount | i18nNum: '$' }}</td>
                    <td class="right aligned">{{ paystub.depositAmount | i18nNum: '$' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</form>
